import CryptoJS from 'crypto-js';
import generateRandomString from './generateRandomString';

function generateCodeChallenge(codeVerifier) {
  return base64URL(CryptoJS.SHA256(codeVerifier));
}

function base64URL(value) {
  return value.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}

export default function generatePkce() {
  var codeVerifier = generateRandomString(128);
  var codeChallenge = generateCodeChallenge(codeVerifier);
  return {
    codeVerifier: codeVerifier,
    codeChallenge: codeChallenge
  };
}